<template>
  <v-container fluid>
    <v-card>
      <v-card-title class="primary white--text">
        Asignaciones V8 - Vista Ejecutivo
        <v-spacer></v-spacer>
        <v-btn color="success" @click="exportarExcel" :disabled="!resumenEjecutivo.length" :loading="exporting" small>
          <v-icon left>mdi-file-excel</v-icon> Exportar Resumen
        </v-btn>
      </v-card-title>
      
      <!-- Filtros de Fecha únicamente -->
      <v-card-text class="pt-4">
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="filtros.fecha_inicio_mes"
              label="Fecha Inicio Mes"
              type="date"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="filtros.fecha_consulta"
              label="Fecha Consulta"
              type="date"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4" class="d-flex align-center">
            <v-btn color="primary" @click="fetchData" :loading="loading" large block>
              <v-icon left>mdi-magnify</v-icon> Consultar Resumen
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>

      <!-- Filtros -->
      <v-card-text v-if="records.length > 0" class="pt-0">
        <v-row dense align="center">
          <v-col cols="12" md="3">
            <v-text-field v-model="busqueda" label="Buscar estudiante, documento, correo o programa"
              prepend-inner-icon="mdi-magnify" outlined dense clearable hide-details></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <v-select v-model="filtroUnidad" :items="opcionesUnidad" label="Unidad" outlined dense hide-details></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <v-select v-model="filtroSede" :items="opcionesSede" label="Sede" outlined dense hide-details></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <v-select v-model="filtroAsignacion" :items="opcionesAsignacion" label="Tipo Asignación" outlined dense hide-details></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <v-select v-model="filtroEstado" :items="opcionesEstado" label="Estado" outlined dense hide-details></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <v-select v-model="filtroTipoPlan" :items="opcionesTipoPlan" label="Tipo Plan" outlined dense hide-details></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <v-select v-model="filtroConceptos" :items="opcionesConcepto" item-text="text" item-value="value"
              label="Conceptos" multiple chips clearable outlined dense hide-details></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <v-btn color="error" outlined block @click="limpiarFiltros">
              <v-icon left>mdi-filter-remove</v-icon>Limpiar
            </v-btn>
          </v-col>
          <v-col cols="12" md="2" class="text-right">
            <v-chip color="primary" outlined small>
              {{ datosFiltrados.length }} de {{ records.length }} registros
            </v-chip>
          </v-col>
        </v-row>
      </v-card-text>

      <!-- Gráfico Resumen -->
      <v-card-text v-show="records.length > 0">
        <v-row>
          <v-col cols="12" md="6" class="mx-auto">
            <h3 class="text-center mb-3">Monto Cobrado por Unidad de Negocio</h3>
            <div style="position: relative; height: 300px;">
              <canvas ref="chartUnidadNegocio"></canvas>
            </div>
          </v-col>
        </v-row>
      </v-card-text>

      <!-- Tabla Resumen Ejecutivo -->
      <v-card-text>
        <v-data-table
          :headers="headersEjecutivo"
          :items="resumenEjecutivo"
          :loading="loading || exporting"
          class="elevation-1"
          group-by="unidad_negocio"
          hide-default-footer
          :items-per-page="-1"
          fixed-header
          height="600"
          dense
        >
          <!-- Subtotales por Unidad de Negocio (alineados con columnas) -->
          <template v-slot:group.header="{ group, isOpen, toggle }">
            <td class="indigo lighten-5">
              <div class="d-flex align-center">
                <v-btn icon small @click="toggle">
                  <v-icon>{{ isOpen ? 'mdi-chevron-down' : 'mdi-chevron-right' }}</v-icon>
                </v-btn>
                <strong class="indigo--text text--darken-3">
                  <v-icon small color="indigo darken-3" left>mdi-domain</v-icon>{{ group }}
                </strong>
              </div>
            </td>
           
            <td class="indigo lighten-5 text-center font-weight-bold">
              {{ totalesPorUnidad[group] ? totalesPorUnidad[group].cantidad_estudiantes : 0 }}
            </td>
            <td class="indigo lighten-5 text-center font-weight-bold">
              {{ totalesPorUnidad[group] ? totalesPorUnidad[group].cantidad_registros : 0 }}
            </td>
            <td class="indigo lighten-5"></td>
            <td class="indigo lighten-5 text-right font-weight-bold">
              {{ formatMonto(totalesPorUnidad[group] ? totalesPorUnidad[group].asignacion : 0) }}
            </td>
            <td class="indigo lighten-5 text-right font-weight-bold orange--text">
              {{ formatMonto(totalesPorUnidad[group] ? totalesPorUnidad[group].monto_revertido : 0) }}
            </td>
            <td class="indigo lighten-5 text-right font-weight-bold deep-orange--text">
              {{ formatMonto(totalesPorUnidad[group] ? totalesPorUnidad[group].monto_descuento : 0) }}
            </td>
            <td class="indigo lighten-5 text-right font-weight-bold purple--text">
              {{ formatMonto(totalesPorUnidad[group] ? totalesPorUnidad[group].cambiado : 0) }}
            </td>
            <td class="indigo lighten-5 text-right font-weight-bold success--text">
              {{ formatMonto(totalesPorUnidad[group] ? totalesPorUnidad[group].monto_pagado : 0) }}
            </td>
            <td class="indigo lighten-5 text-right font-weight-bold"
              :class="totalesPorUnidad[group] && totalesPorUnidad[group].saldo > 0 ? 'error--text' : 'success--text'">
              {{ formatMonto(totalesPorUnidad[group] ? totalesPorUnidad[group].saldo : 0) }}
            </td>
            <td class="indigo lighten-5 text-right font-weight-bold light-green--text text--darken-2">
              {{ formatMonto(totalesPorUnidad[group] ? totalesPorUnidad[group].monto_adelantado : 0) }}
            </td>
            <td class="indigo lighten-5 text-center">
              <v-chip v-if="totalesPorUnidad[group]" :color="getColorPorcentaje(totalesPorUnidad[group].porcentaje)" dark x-small>
                {{ totalesPorUnidad[group].porcentaje.toFixed(2) }}%
              </v-chip>
            </td>
            <td class="indigo lighten-5"></td>
          </template>
          <template v-slot:item.asig_tipos="{ item }">
            <div class="d-flex flex-wrap" style="gap: 2px; max-width: 160px;">
              <v-chip v-for="t in item.asig_tipos" :key="t" :color="colorAsigTipo(t)" x-small dark>
                {{ t }}
              </v-chip>
            </div>
          </template>
          <template v-slot:item.asignacion="{ item }">
            <strong>{{ formatMonto(item.asignacion) }}</strong>
          </template>
          <template v-slot:item.monto_revertido="{ item }">
            <span :class="item.monto_revertido > 0 ? 'orange--text font-weight-bold' : ''">
              {{ formatMonto(item.monto_revertido) }}
            </span>
          </template>
          <template v-slot:item.monto_descuento="{ item }">
            <span :class="item.monto_descuento > 0 ? 'deep-orange--text font-weight-bold' : ''">
              {{ formatMonto(item.monto_descuento) }}
            </span>
          </template>
          <template v-slot:item.cambiado="{ item }">
            <span :class="item.cambiado > 0 ? 'purple--text font-weight-bold' : ''">
              {{ formatMonto(item.cambiado) }}
            </span>
          </template>
          <template v-slot:item.monto_pagado="{ item }">
            <span class="success--text font-weight-bold">{{ formatMonto(item.monto_pagado) }}</span>
          </template>
          <template v-slot:item.saldo="{ item }">
            <strong :class="item.saldo > 0 ? 'error--text' : 'success--text'">
              {{ formatMonto(item.saldo) }}
            </strong>
          </template>
          <template v-slot:item.monto_adelantado="{ item }">
            <span :class="item.monto_adelantado > 0 ? 'light-green--text text--darken-2 font-weight-bold' : ''">
              {{ formatMonto(item.monto_adelantado) }}
            </span>
          </template>
          <template v-slot:item.porcentaje="{ item }">
            <v-chip :color="getColorPorcentaje(item.porcentaje)" dark small>
              {{ item.porcentaje.toFixed(2) }}%
            </v-chip>
          </template>
          <template v-slot:item.acciones="{ item }">
            <v-btn color="info" small @click="verDetalles(item)">
              Ver {{ item.cantidad_registros }} Registros
            </v-btn>
          </template>

          <!-- Fila de Totales Generales -->
          <template v-slot:body.append v-if="resumenEjecutivo.length > 0">
            <tr class="grey lighten-3 font-weight-bold">
              <td colspan="2" class="text-right">TOTAL GENERAL:</td>
              <td class="text-center">{{ totalesGenerales.cantidad_estudiantes }}</td>
              <td class="text-center">{{ totalesGenerales.cantidad_registros }}</td>
              <td></td>
              <td class="text-right">{{ formatMonto(totalesGenerales.asignacion) }}</td>
              <td class="text-right">{{ formatMonto(totalesGenerales.monto_revertido) }}</td>
              <td class="text-right">{{ formatMonto(totalesGenerales.monto_descuento) }}</td>
              <td class="text-right">{{ formatMonto(totalesGenerales.cambiado) }}</td>
              <td class="text-right">{{ formatMonto(totalesGenerales.monto_pagado) }}</td>
              <td class="text-right">{{ formatMonto(totalesGenerales.saldo) }}</td>
              <td class="text-right">{{ formatMonto(totalesGenerales.monto_adelantado) }}</td>
              <td class="text-center">
                <v-chip :color="getColorPorcentaje(totalesGenerales.porcentaje)" dark small>
                  {{ totalesGenerales.porcentaje.toFixed(2) }}%
                </v-chip>
              </td>
              <td></td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <!-- Dialog para ver detalles de la sede seleccionada -->
    <v-dialog v-model="dialogDetalles" max-width="1200px">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          Detalles: {{ seleccion.unidad }} - {{ seleccion.sede }}
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogDetalles = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-4">
          <v-data-table
            :headers="headersDetalle"
            :items="registrosSeleccionados"
            class="elevation-1"
          >
            <template v-slot:item.plan_pago_monto="{ item }">
              Bs {{ formatMonto(parseFloat(item.plan_pago_monto) || 0) }}
            </template>
            <template v-slot:item.pago_monto="{ item }">
              Bs {{ formatMonto(parseFloat(item.pago_monto) || 0) }}
            </template>
            <template v-slot:item.encargado_cobranza="{ item }">
              <div v-if="item.encargado_cobranza" class="d-flex align-center">
                <v-avatar size="28" color="deep-purple" class="mr-2">
                  <span class="white--text text-caption">{{ getIniciales(item.encargado_cobranza) }}</span>
                </v-avatar>
                <span class="caption">{{ item.encargado_cobranza }}</span>
              </div>
              <span v-else class="grey--text">Sin asignar</span>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Snackbar para notificaciones -->
    <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="4000" top>
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">Cerrar</v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import xaxios from '@/xaxios';
import Chart from 'chart.js';
import asignacionFormatos from '@/mixins/asignacionFormatos';

const hoy = new Date();
const primerDiaMes = new Date(hoy.getFullYear(), hoy.getMonth(), 1);
const toISODate = (d) => new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10);

export default {
  name: 'AsignacionesEjecutivoV8',
  mixins: [asignacionFormatos],
  data() {
    return {
      loading: false,
      exporting: false,
      chartInstance: null,
      filtros: {
        fecha_inicio_mes: toISODate(primerDiaMes),
        fecha_consulta: toISODate(hoy),
      },
      busqueda: '',
      filtroEstado: 'todos',
      filtroAsignacion: 'todos',
      filtroTipoPlan: 'todos',
      filtroUnidad: 'todos',
      filtroSede: 'todos',
      filtroConceptos: [],
      records: [],
      dialogDetalles: false,
      seleccion: {
        unidad: '',
        sede: ''
      },
      registrosSeleccionados: [],
      headersEjecutivo: [
        { text: 'Unidad de Negocio', value: 'unidad_negocio' },
        { text: 'Sede', value: 'sede' },
        { text: 'Estudiantes', value: 'cantidad_estudiantes', align: 'center' },
        { text: 'Registros', value: 'cantidad_registros', align: 'center' },
        { text: 'Tipo Asig.', value: 'asig_tipos', sortable: false },
        { text: 'Asignación (Bs)', value: 'asignacion', align: 'right' },
        { text: 'Revertido (Bs)', value: 'monto_revertido', align: 'right' },
        { text: 'Descuento (Bs)', value: 'monto_descuento', align: 'right' },
        { text: 'Cambiado (Bs)', value: 'cambiado', align: 'right' },
        { text: 'Pagado (Bs)', value: 'monto_pagado', align: 'right' },
        { text: 'Saldo (Bs)', value: 'saldo', align: 'right' },
        { text: 'Adelantado (Bs)', value: 'monto_adelantado', align: 'right' },
        { text: '% Cobranza', value: 'porcentaje', align: 'center' },
        { text: 'Acciones', value: 'acciones', sortable: false, align: 'center' },
      ],
      headersDetalle: [
        { text: 'Estudiante', value: 'est_nombres' },
        { text: 'Apellidos', value: 'est_apellidos' },
        { text: 'Programa', value: 'prog_codigo' },
        { text: 'Tipo Registro', value: 'tipo_registro' },
        { text: 'Estado Asig.', value: 'asig_estado' },
        { text: 'Cuota', value: 'plan_pago_cuota' },
        { text: 'Esperado', value: 'plan_pago_monto' },
        { text: 'Pagado', value: 'pago_monto' },
        { text: 'Encargado Cobranza', value: 'encargado_cobranza' },
      ],
    };
  },
  computed: {
    opcionesEstado() { return this.opcionesUnicas('asig_estado', 'Todos'); },
    opcionesAsignacion() { return this.opcionesUnicas('asig_tipo', 'Todas'); },
    opcionesTipoPlan() { return this.opcionesUnicas('ins_tipo_plan', 'Todos'); },
    opcionesUnidad() { return this.opcionesUnicas('prog_unidad_negocio', 'Todas'); },
    opcionesSede() { return this.opcionesUnicas('prog_sede_esam', 'Todas'); },
    opcionesConcepto() {
      const map = new Map();
      this.records.forEach(item => {
        const id = this.getConceptoId(item);
        const nombre = this.getConceptoNombre(item);
        if (id != null && nombre) map.set(id, nombre);
      });
      return Array.from(map, ([value, text]) => ({ value, text })).sort((a, b) => a.text.localeCompare(b.text));
    },
    datosFiltrados() {
      let datos = this.records;
      if (this.filtroAsignacion !== 'todos') datos = datos.filter(i => i.asig_tipo === this.filtroAsignacion);
      if (this.filtroEstado !== 'todos') datos = datos.filter(i => i.asig_estado === this.filtroEstado);
      if (this.filtroTipoPlan !== 'todos') datos = datos.filter(i => i.ins_tipo_plan === this.filtroTipoPlan);
      if (this.filtroUnidad !== 'todos') datos = datos.filter(i => i.prog_unidad_negocio === this.filtroUnidad);
      if (this.filtroSede !== 'todos') datos = datos.filter(i => i.prog_sede_esam === this.filtroSede);
      if (this.filtroConceptos.length > 0) {
        datos = datos.filter(i => this.filtroConceptos.includes(this.getConceptoId(i)));
      }
      if (this.busqueda) {
        const q = this.busqueda.toLowerCase();
        datos = datos.filter(i => [
          i.est_nombres, i.est_apellidos, i.est_num_doc, i.est_correo,
          i.prog_codigo, i.prog_nombre_compuesto,
        ].some(v => String(v || '').toLowerCase().includes(q)));
      }
      return datos;
    },
    totalesPorUnidad() {
      const map = {};
      this.resumenEjecutivo.forEach(item => {
        if (!map[item.unidad_negocio]) {
          map[item.unidad_negocio] = {
            estudiantesSet: new Set(),
            cantidad_registros: 0,
            asignacion: 0,
            monto_revertido: 0,
            monto_descuento: 0,
            cambiado: 0,
            monto_pagado: 0,
            monto_adelantado: 0,
          };
        }
        const u = map[item.unidad_negocio];
        u.cantidad_registros += item.cantidad_registros;
        u.asignacion += item.asignacion;
        u.monto_revertido += item.monto_revertido;
        u.monto_descuento += item.monto_descuento;
        u.cambiado += item.cambiado;
        u.monto_pagado += item.monto_pagado;
        u.monto_adelantado += item.monto_adelantado;
        item.estudiantes.forEach(e => u.estudiantesSet.add(e));
      });
      Object.keys(map).forEach(k => {
        const u = map[k];
        u.cantidad_estudiantes = u.estudiantesSet.size;
        u.saldo = u.asignacion + u.monto_revertido - u.monto_descuento - u.monto_pagado - u.cambiado;
        const base = u.asignacion + u.monto_revertido - u.monto_descuento - u.cambiado;
        u.porcentaje = base > 0 ? (u.monto_pagado / base) * 100 : 0;
      });
      return map;
    },
    resumenEjecutivo() {
      const agrupado = {};

      this.datosFiltrados.forEach((item) => {
        const unidad = item.prog_unidad_negocio || 'Sin Unidad';
        const sede = item.prog_sede_esam || 'Sin Sede';
        const key = `${unidad}|${sede}`;

        if (!agrupado[key]) {
          agrupado[key] = {
            unidad_negocio: unidad,
            sede: sede,
            cantidad_registros: 0,
            estudiantes: new Set(),
            asig_tipos_set: new Set(),
            asignacion: 0,
            monto_revertido: 0,
            monto_descuento: 0,
            cambiado: 0,
            monto_pagado: 0,
            monto_adelantado: 0,
            registros: [],
          };
        }
        const g = agrupado[key];
        g.cantidad_registros += 1;
        g.registros.push(item);
        if (item.est_num_doc) g.estudiantes.add(item.est_num_doc);
        if (item.asig_tipo) g.asig_tipos_set.add(item.asig_tipo);

        const tipo = String(item.tipo_registro || '').trim().toLowerCase();

        if (tipo === 'nuevo') {
          g.asignacion += parseFloat(item.plan_pago_monto) || 0;
        } else if (tipo === 'dw') {
          g.asignacion += parseFloat(item.plan_pago_monto_saldo_inicio) || 0;
          if (item.plan_modificado == 1) {
            g.cambiado += parseFloat(item.plan_pago_monto_saldo_inicio) || 0;
          }
        } else if (tipo === 'descuento_revertido') {
          g.monto_revertido += parseFloat(item.descuento_monto_revertido) || 0;
        } else if (tipo === 'descuento_aprobado') {
          g.monto_descuento += parseFloat(item.descuento_monto_revertido) || 0;
        } else if (tipo === 'pagado') {
          const monto = parseFloat(item.pago_monto) || 0;
          if (item.asig_estado === 'adelantado') {
            g.monto_adelantado += monto;
          } else {
            g.monto_pagado += monto;
          }
        }
      });

      return Object.values(agrupado).map(g => {
        const saldo = g.asignacion + g.monto_revertido - g.monto_descuento - g.monto_pagado - g.cambiado;
        const base = g.asignacion + g.monto_revertido - g.monto_descuento - g.cambiado;
        return {
          ...g,
          cantidad_estudiantes: g.estudiantes.size,
          asig_tipos: Array.from(g.asig_tipos_set).sort(),
          saldo,
          porcentaje: base > 0 ? (g.monto_pagado / base) * 100 : 0,
        };
      }).sort((a, b) => b.asignacion - a.asignacion);
    },
    datosGraficoUnidadNegocio() {
      const agrupado = {};
      this.resumenEjecutivo.forEach((grupo) => {
        if (!agrupado[grupo.unidad_negocio]) agrupado[grupo.unidad_negocio] = 0;
        agrupado[grupo.unidad_negocio] += grupo.monto_pagado;
      });
      return {
        labels: Object.keys(agrupado),
        data: Object.values(agrupado),
      };
    },
    totalesGenerales() {
      const t = {
        cantidad_registros: 0,
        cantidad_estudiantes: 0,
        asignacion: 0,
        monto_revertido: 0,
        monto_descuento: 0,
        cambiado: 0,
        monto_pagado: 0,
        monto_adelantado: 0,
      };
      const estudiantesGlobal = new Set();

      this.resumenEjecutivo.forEach((item) => {
        t.cantidad_registros += item.cantidad_registros;
        t.asignacion += item.asignacion;
        t.monto_revertido += item.monto_revertido;
        t.monto_descuento += item.monto_descuento;
        t.cambiado += item.cambiado;
        t.monto_pagado += item.monto_pagado;
        t.monto_adelantado += item.monto_adelantado;
        item.estudiantes.forEach(e => estudiantesGlobal.add(e));
      });
      t.cantidad_estudiantes = estudiantesGlobal.size;

      const saldo = t.asignacion + t.monto_revertido - t.monto_descuento - t.monto_pagado - t.cambiado;
      const base = t.asignacion + t.monto_revertido - t.monto_descuento - t.cambiado;
      return {
        ...t,
        saldo,
        porcentaje: base > 0 ? (t.monto_pagado / base) * 100 : 0,
      };
    },
  },
  watch: {
    records() {
      this.$nextTick(() => {
        this.renderChart();
      });
    }
  },
  methods: {
    async fetchData() {
      if (this.filtros.fecha_inicio_mes > this.filtros.fecha_consulta) {
        this.mostrarNotificacion('La fecha de inicio no puede ser mayor a la fecha de consulta.', 'error');
        return;
      }
      this.loading = true;
      try {
        const response = await xaxios.get(`${process.env.VUE_APP_API_REST}/api/v8/esam/asignacion/programas`, {
          params: {
            fecha_inicio_mes: this.filtros.fecha_inicio_mes,
            fecha_consulta: this.filtros.fecha_consulta,
          },
        });

        this.records = response.data.data || [];
        if (this.records.length === 0) {
          this.mostrarNotificacion('No se encontraron registros para el rango seleccionado.', 'info');
        }
      } catch (error) {
        const detalle = error?.response?.data?.message || error?.response?.data?.error || error?.message || '';
        const texto = detalle ? `Error al obtener los registros: ${detalle}` : 'Error al obtener los registros';
        this.mostrarNotificacion(texto, 'error');
        window.console.error('Error al obtener datos V8 Ejecutivo:', error);
      } finally {
        this.loading = false;
      }
    },
    verDetalles(item) {
      this.seleccion.unidad = item.unidad_negocio;
      this.seleccion.sede = item.sede;
      this.registrosSeleccionados = [...item.registros];
      this.dialogDetalles = true;
    },
    getColorPorcentaje(porcentaje) {
      const val = parseFloat(porcentaje);
      if (val >= 80) return 'green';
      if (val >= 50) return 'orange';
      return 'red';
    },
    colorAsigTipo(tipo) {
      const t = String(tipo || '').toLowerCase();
      if (t.includes('cobranza') || t.includes('cartera')) return 'red darken-2';
      if (t.includes('marketing') || t.includes('nuevos') || t.includes('inscritos')) return 'green darken-2';
      return 'blue-grey';
    },
    opcionesUnicas(campo, textoTodos) {
      const opciones = [{ text: textoTodos, value: 'todos' }];
      const valores = new Set(this.records.map(item => item[campo]).filter(Boolean));
      Array.from(valores).sort().forEach(value => opciones.push({ text: value, value }));
      return opciones;
    },
    getConceptoId(item) {
      return item.plan_pago_concepto || null;
    },
    getConceptoNombre(item) {
      return item.plan_pago_concepto || '';
    },
    limpiarFiltros() {
      this.busqueda = '';
      this.filtroEstado = 'todos';
      this.filtroAsignacion = 'todos';
      this.filtroTipoPlan = 'todos';
      this.filtroUnidad = 'todos';
      this.filtroSede = 'todos';
      this.filtroConceptos = [];
    },
    exportarExcel() {
      if (!this.resumenEjecutivo.length) return;
      
      this.exporting = true;

      this.$nextTick(() => {
        try {
          const headers = ['Unidad de Negocio', 'Sede', 'Estudiantes', 'Registros', 'Tipo Asig.', 'Asignación', 'Revertido', 'Descuento', 'Cambiado', 'Pagado', 'Saldo', 'Adelantado', '% Cobranza'];
          const rows = this.resumenEjecutivo.map(item => [
            `"${item.unidad_negocio}"`,
            `"${item.sede}"`,
            item.cantidad_estudiantes,
            item.cantidad_registros,
            `"${item.asig_tipos.join(', ')}"`,
            item.asignacion.toFixed(2),
            item.monto_revertido.toFixed(2),
            item.monto_descuento.toFixed(2),
            item.cambiado.toFixed(2),
            item.monto_pagado.toFixed(2),
            item.saldo.toFixed(2),
            item.monto_adelantado.toFixed(2),
            item.porcentaje.toFixed(2),
          ]);

          rows.push([
            '"TOTAL GENERAL"',
            '""',
            this.totalesGenerales.cantidad_estudiantes,
            this.totalesGenerales.cantidad_registros,
            '""',
            this.totalesGenerales.asignacion.toFixed(2),
            this.totalesGenerales.monto_revertido.toFixed(2),
            this.totalesGenerales.monto_descuento.toFixed(2),
            this.totalesGenerales.cambiado.toFixed(2),
            this.totalesGenerales.monto_pagado.toFixed(2),
            this.totalesGenerales.saldo.toFixed(2),
            this.totalesGenerales.monto_adelantado.toFixed(2),
            this.totalesGenerales.porcentaje.toFixed(2),
          ]);

          const csvContent = [headers.join(';')].concat(rows.map(e => e.join(';'))).join('\n');
          const blob = new Blob(["\ufeff", csvContent], { type: 'text/csv;charset=utf-8;' });
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.setAttribute('href', url);
          link.setAttribute('download', 'Resumen_Ejecutivo_V8.csv');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } catch (error) {
          this.mostrarNotificacion('Error al exportar a CSV.', 'error');
          window.console.error('Error exportando excel:', error);
        } finally {
          this.exporting = false;
        }
      });
    },
    renderChart() {
      if (this.chartInstance) {
        this.chartInstance.destroy();
        this.chartInstance = null;
      }
      const ctx = this.$refs.chartUnidadNegocio;
      if (!ctx) return;

      const chartData = this.datosGraficoUnidadNegocio;
      const backgroundColors = ['#1976d2', '#388e3c', '#f57c00', '#e53935', '#8e24aa', '#00acc1', '#fb8c00', '#43a047'];

      this.chartInstance = new Chart(ctx.getContext('2d'), {
        type: 'doughnut',
        data: {
          labels: chartData.labels,
          datasets: [{
            data: chartData.data,
            backgroundColor: backgroundColors.slice(0, chartData.labels.length),
            borderWidth: 1
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: { position: 'bottom' },
          tooltips: {
            callbacks: {
              label: function(tooltipItem, data) {
                const label = data.labels[tooltipItem.index] || '';
                const value = data.datasets[0].data[tooltipItem.index];
                return `${label}: ${Number(value).toLocaleString('es-BO', {minimumFractionDigits: 2, maximumFractionDigits: 2})} Bs.`;
              }
            }
          }
        }
      });
    }
  },
  beforeDestroy() {
    if (this.chartInstance) {
      this.chartInstance.destroy();
    }
  }
};
</script>